// ProductType Vuex

import state from './weightAuditorStates.js'
import * as getters from './weightAuditorGetters.js'
import * as mutations from './weightAuditorMutations.js'
import * as actions from './weightAuditorActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
